export default __webpack_public_path__ + "static/wide-silhouette-circle-c88bb0d6927597c4e411b68e8f4142f8.png";